(function (KinderEnroll, $, undefined) {
    /**
     * @memberOf KinderEnroll
     */
    KinderEnroll.Pages = KinderEnroll.Pages || {};

    (function (Pages, $, undefined) {
        /**
         * @memberOf KinderEnroll.Pages
         */
        KinderEnroll.Pages.Shared = Pages.Shared || {};

        (function (Notifications, $, undefined) {
            if (Lfl.Files.isLoadedAlready(KinderEnroll.Pages.Shared, 'UserFormFieldsDirector')) {
                return;
            }

            /*
             |==========================================================================================================
             | Class definition
             |==========================================================================================================
             */

            /**
             * Page director
             *
             * @param {object} parameters
             * @param {boolean} parameters.isUserLoggedIn
             * @param {string} parameters.childDefaultDate
             * @param {string} parameters.userDefaultDate
             *
             *
             * @memberOf KinderEnroll.Pages.Shared
             * @lends KinderEnroll.Pages.Shared.UserFormFieldsDirector
             * @constructor
             */
            KinderEnroll.Pages.Shared.UserFormFieldsDirector = function (parameters) {
                var VISIBILITY_CONTROLLING_CHECKBOX_NAME_FORMAT = ':userFieldId[isExistingUser]';
                var VISIBILITY_CONTROLLED_ELEMENT_PATH_FORMAT = '[data-lfl-existing-user-control~="visibility-depends-:userNo"]';
                var DATEPICKER_PATH = '[data-lfl-users-input=":userFieldId-human-readable-birth-date-datepicker"] input';
                var USER_NO_INPUT_PATH = 'input[data-lfl-additional-users-role~="user-no"]';

                var USER_NO_PLACEHOLDER = ':userNo';
                var USER_FIELD_ID_PLACEHOLDER = ':userFieldId';
                // Link:: KinderEnroll::V::AdditionalUsers::Format
                var ADDITIONAL_USER_FIELD_ID_FORMAT = 'additional-user-:userNo';
                var PRIMARY_USER_FIELD_ID_FORMAT = 'primary-user';

                var CHILD_INPUT_PATH = '#child_human_readable_birth_date_datepicker input';

                var ADD_USER_TEMPLATE_PATH = '[data-lfl-additional-users~="template"]';
                var ADDITIONAL_USERS_CONTAINER_PATH = '[data-lfl-additional-users~="container"]';

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Construction
                 |------------------------------------------------------------------------------------------------------
                 */

                var userDefaultDate = parameters.userDefaultDate;

                var datepickerOptions = {
                    startView: 2,
                    orientation: "bottom left",
                    autoclose: true,
                    maxViewMode: 2
                };

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Public methods
                 |------------------------------------------------------------------------------------------------------
                 */

                this.initDatepickers = function () {
                    // Note: Using init via Javascript (not via builder) because there are other datepickers on this
                    //  page, that are dynamically added by user via JS (that can't use builder, see AdditionalUserHandler.initDatepickers())
                    Lfl.Forms.Inputs.Datepicker.initPicker({
                        $element: $(CHILD_INPUT_PATH),
                        datepickerOptions:
                            $.extend({}, datepickerOptions, {defaultViewDate: parameters.childDefaultDate})
                    });

                    if (false === parameters.isUserLoggedIn) {
                        Lfl.Forms.Inputs.Datepicker.initPicker({
                            $element: $(UserFieldIdReplacer.primary(DATEPICKER_PATH)),
                            datepickerOptions:
                                $.extend({}, datepickerOptions, {defaultViewDate: userDefaultDate})
                        });
                    }
                };

                this.initAdditionalUsers = function() {
                    UsersHandlingManager.init();
                };

                this.scrollToFirstPanel = function() {
                    $('.content-wrapper')[0].scrollIntoView({behavior: "smooth"});
                };

                this.addUser = function() {
                    UsersHandlingManager.add();
                };

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Inner classes
                 |------------------------------------------------------------------------------------------------------
                 */

                /**
                 * Manages all the additional users.
                 *
                 * @param {object} parameters
                 */
                var UsersHandlingManager = function (parameters) {
                    var $addUserTemplate;
                    var $additionalUsersContainer;
                    var counter = 1;

                    /**
                     * @memberOf UsersHandlingManager
                     */
                    this.init = function () {
                        $addUserTemplate = $(ADD_USER_TEMPLATE_PATH);
                        $additionalUsersContainer = $(ADDITIONAL_USERS_CONTAINER_PATH);
                        $addUserTemplate.detach();

                        $('[data-lfl-additional-users~="previously-submitted"]').each(function (){
                            var $container = $(this);
                            var userNo = parseInt($container.find(USER_NO_INPUT_PATH).val());
                            if(userNo >= counter) {
                                counter = userNo + 1;
                            }
                            var handler = new AdditionalUserHandler({userNo: userNo});

                            handler.handlePreviouslySubmitted({
                                $previouslySubmittedUserContainer: $container
                            });
                        });
                    }

                    /**
                     * @memberOf UsersHandlingManager
                     */
                    this.add = function () {
                        var handler = new AdditionalUserHandler({userNo: counter++});

                        handler.handleAdded({
                            $addUserTemplate: $addUserTemplate,
                            $additionalUsersContainer: $additionalUsersContainer
                        });
                    }

                    return this;
                }({});

                /**
                 * Handles a single additional user.
                 *
                 * @param {object} parameters
                 * @param {int|string} parameters.userNo
                 * @lends AdditionalUserHandler
                 * @constructor
                 */
                function AdditionalUserHandler (parameters) {
                    var $container
                    var userNo = parameters.userNo;

                    /**
                     * @param {object} parameters
                     * @param {jQuery} parameters.$addUserTemplate
                     * @param {jQuery} parameters.$additionalUsersContainer
                     */
                    this.handleAdded = function (parameters) {
                        $container = parameters.$addUserTemplate.clone();

                        var html = $container.html();
                        html = html.replaceAll(USER_NO_PLACEHOLDER, userNo);
                        $container.html(html);

                        if($container.attr('data-lfl-additional-users') !== "template") {
                            console.error("Container does not have proper data attribute!", {
                                $container: $container
                            });
                        }

                        $container.attr('data-lfl-additional-users', 'dynamically-added')
                            .removeClass('hidden');

                        parameters.$additionalUsersContainer.append($container);


                        handleContainer();
                    };

                    /**
                     * @param {object} parameters
                     * @param {jQuery} parameters.$previouslySubmittedUserContainer
                     */
                    this.handlePreviouslySubmitted = function (parameters) {
                        $container = parameters.$previouslySubmittedUserContainer;

                        handleContainer();
                    };

                    /*
                    |-------------------------------------------------------------------------
                    | Private methods */
                    /**
                     * Generic method unrelated to method of container creation (added/already submitted).
                     */
                    function handleContainer() {
                        var existingUserNo = $container.attr('data-lfl-additional-users-no');
                        if(typeof existingUserNo !== 'undefined' && parseInt(existingUserNo) !== userNo) {
                            console.error("UserNo does not match!", {
                                $container: $container,
                                existingUserNo: existingUserNo,
                                userNo: userNo
                            });
                        }
                        // Note: ::AdditionalUsers::UserNo - We set the userNo data in JS to make sure it stays synced.
                        $container.attr('data-lfl-additional-users-no', userNo);

                        /*
                        |-------------------------------------------------------------------------
                        | Init elements behaviour */
                        if($container.find('[data-lfl-additional-users-role~="existing-user-hidden"]').length === 0) {
                            // Only init vdoi if the checkbox is active. Alternative: check if checkbox disabled.
                            initVisibilityDependence();
                        }

                        initDatepickers();

                        var $removeButton = $container.find('[data-lfl-additional-users~="remove-button"]');
                        $removeButton.on('click', remove);
                    }

                    function remove() {
                        $container.remove();
                    }

                    function initVisibilityDependence() {
                        var controllingInputName = UserFieldIdReplacer.additional(VISIBILITY_CONTROLLING_CHECKBOX_NAME_FORMAT, userNo);
                        var controlledElementPath = VISIBILITY_CONTROLLED_ELEMENT_PATH_FORMAT.replace(USER_NO_PLACEHOLDER, userNo);
                        var values = true;
                        var type = 'checkbox';

                        var controllingInput = new Lfl.VisibilityDependence.VdoiControllingInputResolver({
                            name: controllingInputName,
                            desiredValue: values,
                            type: type
                        });

                        var evdoi = new Lfl.VisibilityDependence.ElementVdoiCoordinator({
                            controllingInput: controllingInput,
                            dependentElementPath: controlledElementPath
                        });
                        evdoi.activate();
                    }

                    function initDatepickers () {
                        var datepickerPath = UserFieldIdReplacer.additional(DATEPICKER_PATH, userNo);

                        Lfl.Forms.Inputs.Datepicker.initPicker({
                            $element: $(datepickerPath),
                            datepickerOptions:
                                $.extend({}, datepickerOptions, {defaultViewDate: userDefaultDate})
                        });
                    }
                }

                var UserFieldIdReplacer = {
                    primary: function (string) {
                        return string.replace(USER_FIELD_ID_PLACEHOLDER, PRIMARY_USER_FIELD_ID_FORMAT);
                    },
                    additional: function (string, userNo) {
                        return string
                            .replace(USER_FIELD_ID_PLACEHOLDER, ADDITIONAL_USER_FIELD_ID_FORMAT)
                            .replace(USER_NO_PLACEHOLDER, userNo);
                    },

                }
            };
        }(Pages.Shared, jQuery));
    }(KinderEnroll.Pages, jQuery));
}(window.KinderEnroll = window.KinderEnroll || {}, jQuery));
